/** @jsxImportSource @emotion/react */
import { css, SerializedStyles } from "@emotion/react";
import React from "react";
import { IconWrapperRounded } from "./IconWrapperRounded";
import { colors } from "./colors";
import { StyledText } from "../assets/typography/typography";
import { VerticalDivider } from "./VerticalDivider";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  additionalStyles?: SerializedStyles;
  label: string;
  onButtonClick?: () => void;
  buttonIcon?: React.ReactNode;
  icon: React.ReactNode;
  children?: React.ReactNode;
}

const buttonWrapperStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const buttonStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  height: 100%;
  color: ${colors.textSecondary};
  padding-right: 12px;
  padding-left: 8px;
  padding-top: 4px;
  padding-bottom: 4px;
  cursor: pointer;
  &:hover {
    color: ${colors.textPrimary};
  }
`;

const textStyle = css`
  display: flex;
`;

export const RoundedActionLabel = ({
  additionalStyles,
  label,
  onButtonClick,
  buttonIcon,
  icon,
  children,
  ...rest
}: Props) => {
  const wrapperStyle = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    min-width: fit-content;
    height: fit-content;
    min-height: fit-content;
    gap: 8px;
    overflow: clip;
    border-radius: 9999px;
    background-color: ${colors.white};
    ${additionalStyles}
  `;

  const contentWrapperStyle = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 8px;
    padding-top: 4px;
    padding-bottom: 4px;
    ${(!buttonIcon || !onButtonClick) && `padding-right: 12px;`}
    width: fit-content;
    min-width: fit-content;
    height: fit-content;
    min-height: fit-content;
    gap: 8px;
  `;

  return (
    <div css={wrapperStyle} {...rest}>
      <div css={contentWrapperStyle}>
        <IconWrapperRounded backgroundColor={colors.transparent}>
          {icon}
        </IconWrapperRounded>
        <StyledText css={textStyle} className="bodyTextSemibold mb-0">
          {label}
        </StyledText>
        {children}
      </div>
      {onButtonClick && buttonIcon && (
        <div css={buttonWrapperStyle}>
          <VerticalDivider height="16px" backgroundColor={colors.greyBorder} />
          <button css={buttonStyle} onClick={onButtonClick}>
            <StyledText css={textStyle} className="bodyTextSemibold mb-0">
              {buttonIcon}
            </StyledText>
          </button>
        </div>
      )}
    </div>
  );
};
